import { api as AxiosRepository } from "./AxiosRepository";
const apiVersionBaseUrl = "/v1/paymentmethods";

export default {
  getPaymentMethods() {
    return AxiosRepository.get(apiVersionBaseUrl).then((response) => response.data);
  }
};
